import { render } from "./FairRoll.vue?vue&type=template&id=2076eef7&scoped=true"
import script from "./FairRoll.vue?vue&type=script&lang=js"
export * from "./FairRoll.vue?vue&type=script&lang=js"

import "./FairRoll.vue?vue&type=style&index=0&id=2076eef7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2076eef7"]])

export default __exports__